export const IMPRESSION = 'impression';
export const UI_CLICK = 'ui_click';
